// ModuleProgress.tsx — per-module progress beads + "n of total" label.
import { Beads, Meta } from './ui';
import type { Module } from '@/types';
import type { ProgressState } from '@/services/progress';
import { moduleProgress, moduleStatus } from '@/services/contentProvider';
import type { Programme } from '@/types';

export function ModuleProgress({
  programme,
  module,
  progress,
}: {
  programme: Programme;
  module: Module;
  progress: ProgressState;
}) {
  const { done, total } = moduleProgress(module, progress);
  const status = moduleStatus(programme, module, progress);
  if (status === 'soon') return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <Beads
        total={total}
        done={done}
        current={status === 'current'}
        color={status === 'done' ? 'var(--green)' : 'var(--amber)'}
      />
      <Meta>
        {done} of {total}
      </Meta>
    </div>
  );
}
